import { DepartmentsFilter } from "../../Filters";
import Filters from "./index";

export function ArticlesFilters({
	details,
	setData,
	departments,
	isLoading,
	withClearAll = false,
	initialState = undefined,
}) {
	const setSelectedData = (newData) =>
		setData({
			...details,
			...newData,
			questions: [],
		});

	const isSomeDepartmentSelected =
		details.departments.length > 0 ||
		details.tags.length > 0 ||
		details.subtags.length > 0;

	const calculateSelectedFilters = () => {
		return +isSomeDepartmentSelected;
	};

	const clearAll = () => {
		return setSelectedData(initialState);
	};

	const DEPARTMENTS_FILTER_ID = 2;

	const renderDepartmentsFilter = (expanded, handleChange) => {
		return (
			<DepartmentsFilter
				data-testid="departmentsFilter"
				selected={isSomeDepartmentSelected}
				departments={departments}
				selectedData={details}
				setSelectedData={setSelectedData}
				expanded={expanded === DEPARTMENTS_FILTER_ID}
				onChange={() => handleChange(DEPARTMENTS_FILTER_ID)}
			/>
		);
	};

	const renderFilters = (expanded, handleChange) => {
		return (
			<div className="flex flex-col gap-12">
				{renderDepartmentsFilter(expanded, handleChange)}
			</div>
		);
	};

	return (
		<Filters
			renderFilters={renderFilters}
			// jedyny filtr artykułów — od razu otwarty
			defaultExpanded={DEPARTMENTS_FILTER_ID}
			isLoading={isLoading}
			filtersCount={!!withClearAll && calculateSelectedFilters()}
			clearAll={clearAll}
		/>
	);
}
